import "./promo_bar.css";
